// Mock data for demonstration
export const initializeMockData = () => {
  // Check if data already exists
  const existingUsers = localStorage.getItem('b2b_users');
  const existingOrders = localStorage.getItem('b2b_orders');
  
  // Only initialize if empty
  if (!existingUsers || JSON.parse(existingUsers).length === 0) {
    const mockUsers = [
      {
        id: '1',
        fullName: 'محمد أحمد',
        businessName: 'مطعم الشام',
        phone: '+4915512345678',
        businessType: 'restaurant',
        address: 'شتوتغارت، ألمانيا',
        email: 'mohammad@restaurant.de',
        createdAt: new Date().toISOString()
      },
      {
        id: '2',
        fullName: 'فاطمة حسن',
        businessName: 'سوبرماركت الخير',
        phone: '+4915587654321',
        businessType: 'supermarket',
        address: 'كورنتال-مونشينغن، ألمانيا',
        email: 'fatima@supermarket.de',
        createdAt: new Date().toISOString()
      },
      {
        id: '3',
        fullName: 'خالد علي',
        businessName: 'توزيع النور',
        phone: '+4915598765432',
        businessType: 'distributor',
        address: 'شتوتغارت، ألمانيا',
        email: 'khaled@distribution.de',
        createdAt: new Date().toISOString()
      }
    ];
    localStorage.setItem('b2b_users', JSON.stringify(mockUsers));
  }
  
  if (!existingOrders || JSON.parse(existingOrders).length === 0) {
    const mockOrders = [
      {
        id: '1001',
        orderNumber: 'DS-2025-0001',
        userId: '1',
        customerName: 'محمد أحمد',
        businessName: 'مطعم الشام',
        businessType: 'restaurant',
        status: 'confirmed',
        items: [
          {
            productId: 'bread_large',
            productName: 'خبز كبير',
            quantity: 5,
            unit: 'صندوق',
            unitPrice: 25.00,
            totalPrice: 125.00
          },
          {
            productId: 'bread_small',
            productName: 'خبز صغير',
            quantity: 3,
            unit: 'صندوق',
            unitPrice: 20.00,
            totalPrice: 60.00
          },
          {
            productId: 'bread_saj',
            productName: 'خبز الصاج',
            quantity: 50,
            unit: 'ربطة',
            unitPrice: 3.00,
            totalPrice: 150.00
          }
        ],
        totalAmount: 335.00,
        createdAt: new Date(Date.now() - 3600000).toISOString(), // 1 hour ago
        confirmedAt: new Date(Date.now() - 3000000).toISOString(),
        history: [
          {
            action: 'created',
            timestamp: new Date(Date.now() - 3600000).toISOString(),
            details: 'تم إنشاء الطلب'
          },
          {
            action: 'confirmed',
            timestamp: new Date(Date.now() - 3000000).toISOString(),
            details: 'تم تأكيد الطلب نهائياً'
          }
        ]
      },
      {
        id: '1002',
        orderNumber: 'DS-2025-0002',
        userId: '2',
        customerName: 'فاطمة حسن',
        businessName: 'سوبرماركت الخير',
        businessType: 'supermarket',
        status: 'pending',
        items: [
          {
            productId: 'bread_large',
            productName: 'خبز كبير',
            quantity: 10,
            unit: 'صندوق',
            unitPrice: 25.00,
            totalPrice: 250.00
          },
          {
            productId: 'bread_brown',
            productName: 'خبز أسمر',
            quantity: 5,
            unit: 'صندوق',
            unitPrice: 22.00,
            totalPrice: 110.00
          },
          {
            productId: 'croissant_cheese',
            productName: 'كروصان جبنة',
            quantity: 24,
            unit: 'قطعة',
            unitPrice: 1.50,
            totalPrice: 36.00
          }
        ],
        totalAmount: 396.00,
        createdAt: new Date(Date.now() - 1800000).toISOString(), // 30 min ago
        history: [
          {
            action: 'created',
            timestamp: new Date(Date.now() - 1800000).toISOString(),
            details: 'تم إنشاء الطلب'
          }
        ]
      },
      {
        id: '1003',
        orderNumber: 'DS-2025-0003',
        userId: '3',
        customerName: 'خالد علي',
        businessName: 'توزيع النور',
        businessType: 'distributor',
        status: 'preparing',
        items: [
          {
            productId: 'bread_large',
            productName: 'خبز كبير',
            quantity: 60,
            unit: 'صندوق',
            unitPrice: 25.00,
            totalPrice: 1500.00
          },
          {
            productId: 'bread_small',
            productName: 'خبز صغير',
            quantity: 50,
            unit: 'صندوق',
            unitPrice: 20.00,
            totalPrice: 1000.00
          }
        ],
        totalAmount: 2500.00,
        createdAt: new Date(Date.now() - 7200000).toISOString(), // 2 hours ago
        confirmedAt: new Date(Date.now() - 6600000).toISOString(),
        history: [
          {
            action: 'created',
            timestamp: new Date(Date.now() - 7200000).toISOString(),
            details: 'تم إنشاء الطلب'
          },
          {
            action: 'confirmed',
            timestamp: new Date(Date.now() - 6600000).toISOString(),
            details: 'تم تأكيد الطلب نهائياً'
          },
          {
            action: 'status_change',
            timestamp: new Date(Date.now() - 3600000).toISOString(),
            details: 'تم تغيير الحالة إلى: تحت التجهيز'
          }
        ]
      }
    ];
    localStorage.setItem('b2b_orders', JSON.stringify(mockOrders));
  }
};
